import { useState, useEffect } from 'react';
import {
  useApi,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { AdminApiClient } from '../api/AdminApiClient';

export function useAdminAccess(): {
  isAdmin: boolean;
  pluginAccess: Record<string, boolean>;
  loading: boolean;
  error: Error | undefined;
} {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const identityApi = useApi(identityApiRef);

  const [isAdmin, setIsAdmin] = useState(false);
  const [pluginAccess, setPluginAccess] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    const client = new AdminApiClient(discoveryApi, fetchApi);

    const fetchData = async () => {
      try {
        // Get email from the auth profile (Microsoft OAuth provides this)
        const profile = await identityApi.getProfileInfo();
        const email = profile.email || '';

        const [adminResult, accessResult] = await Promise.all([
          client.checkAdmin(email),
          client.checkAccess(email),
        ]);
        if (!cancelled) {
          setIsAdmin(adminResult.isAdmin);
          setPluginAccess(accessResult);
          setLoading(false);
        }
      } catch (err) {
        if (!cancelled) {
          setIsAdmin(false);
          setPluginAccess({});
          setError(err instanceof Error ? err : new Error(String(err)));
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [discoveryApi, fetchApi, identityApi]);

  return { isAdmin, pluginAccess, loading, error };
}
